<template>
	<div class="app-nav-skeleton p-4 border-r border-primary" :class="{ 'bg-shade-2' : !isMobile }">
		<div class="flex gap-4 items-center mb-4">
			<div class="app-nav-skeleton__logo rounded-full skeleton--shade-4" />
			<div class="app-nav-skeleton__org-name w-33 skeleton--shade-4" />
			<div v-if="isMobile" class="app-nav-skeleton__logo rounded-full shrink-0 ml-auto h-4 skeleton--shade-4" />
			<div v-if="isMobile" class="app-nav-skeleton__logo rounded-full shrink-0 h-4 skeleton--shade-4" />
		</div>
		<div v-if="!isMobile" class="app-nav-skeleton__main flex items-center mb-5">
			<div class="h-4 skeleton--shade-4" />
			<div class="h-4 skeleton--shade-4" />
			<div class="h-4 skeleton--shade-4" />
			<div class="app-nav-skeleton__icon shrink-0  ml-auto h-4 skeleton--shade-4" />
			<div class="app-nav-skeleton__icon shrink-0  h-4 skeleton--shade-4" />
		</div>
		<div v-if="isMobile" class="flex items-center gap-4 mb-5">
			<div class="grow h-5 skeleton--shade-4" />
			<div class="app-nav-skeleton__icon shrink-0 h-4 skeleton--shade-4" />
		</div>
		<CFormTreeSkeleton class="app-nav-skeleton__form-list" />
		<div v-if="isMobile" class="absolute left-0 right-0 bottom-0 flex item-center justify-around border-primary border-t py-4">
			<div class="skeleton--shade-4 h-5 w-5 my-2"></div>
			<div class="skeleton--shade-4 h-5 w-5 my-2"></div>
			<div class="skeleton--shade-4 h-5 w-5 my-2"></div>
		</div>
	</div>
</template>

<script>
	import { defineComponent, inject } from 'vue';
	import CFormTreeSkeleton from './FormTreeSkeleton.vue';
	import { isMobileKey } from 'src/utilities/injection-keys';

	export default defineComponent({
		name: 'AppNavSkeleton',
		components: { CFormTreeSkeleton },
		setup() {
			const isMobile = inject(isMobileKey);

			return {
				isMobile
			};
		}
	});
</script>

<style lang="scss">
.app-nav-skeleton {
	height: 100vh;

	&__logo {
		width: 30px;
		height: 30px;
	}

	&__org-name {
		height: 18px;
	}

	&__main {
		gap: 23px;

		> div:not(.app-nav-skeleton__icon) {
			width: 4.75em;
		}
	}

	&__icon {
		width: $size__icon;
	}

	&__form-list {
		margin-top: 25px;
	}
}
</style>